/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 11:12:46
 * @LastEditors: K
 * @LastEditTime: 2022-08-12 11:18:21
 */
import { Button, Col } from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { ThemeContext } from '../../theme/ThemeContext'
import { OrderManagement } from './orderManagement'
import { ServerManagement } from './ServerManagement'
import { useLocation } from 'react-router-dom'
import { Tenants } from './Tenants'

export const TenantNavBar = (): ReactElement => {
  const location: any = useLocation()

  const [selectedTab, setSelectedTab] = useState('0')

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  useEffect(() => {
    setSelectedTab(location?.state?.station || storageParams.state)
  }, [location?.state])
  return (
    <Col
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar
        destroyInactiveTabPane
        activeKey={selectedTab}
        onChange={(v) => {
          setSelectedTab(v)
        }}
        style={{ margin: '10px 20px' }}
      >
        <TabPane key='0' tab='机构管理'>
          <Tenants state={selectedTab} />
        </TabPane>

        <TabPane key='1' tab='订单管理'>
          <OrderManagement state={selectedTab} />
        </TabPane>
        <TabPane key='2' tab='批量设置'>
          <Tenants state={selectedTab} />
        </TabPane>
        <TabPane key='3' tab='服务管理'>
          <ServerManagement state={selectedTab} />
        </TabPane>
      </TabBar>
    </Col>
  )
}
